import * as Rx from 'rxjs/Rx'
import { ActionsObservable, combineEpics } from 'redux-observable'
import { AnyAction } from 'typescript-fsa'
import { Store } from 'redux'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { EventHub } from '../../actions'
import {
  isMoveEvent,
  isPresentEvent,
  isSpeakEvent,
  parseBlockEvent,
  parseMapObjectEvent
} from '../../io/events'

// Subscribe
export const subscribe = (
  action$: ActionsObservable<AnyAction>,
  store: Store<State>,
  { logger, appContext }: Dependencies
) =>
  action$.filter(EventHub.subscribe.match).mergeMap(action => {
    const { eventHub } = appContext.clientSession!
    const { channel, tag } = action.payload
    return eventHub
      .subscribe(channel)
      .takeUntil(
        action$
          .filter(EventHub.unsubscribe.match)
          .filter(unsubscribe => unsubscribe.payload === channel)
      )
      .concatMap(payload => {
        if (tag === 'block') {
          const events = parseBlockEvent(payload)
          return Rx.Observable.from(
            events.map(event =>
              EventHub.eventUpdate({ event, channel, tag, lastID: event.id })
            )
          )
          // TODO: handle other tags here
        } else if (tag === 'map_object') {
          const events = parseMapObjectEvent(payload).map(event => {
            // translate image position from legacy CRS to wander CRS
            const { legacyCRS } = appContext.clientSession!
            if (isPresentEvent(event)) {
              return {
                ...event,
                position: legacyCRS.legacyToWander(event.position)
              }
            } else if (isMoveEvent(event)) {
              return {
                ...event,
                source: legacyCRS.legacyToWander(event.source),
                destination: legacyCRS.legacyToWander(event.destination)
              }
            } else if (isSpeakEvent(event)) {
              const index = store
                .getState()
                .world.pendingMessages.findIndex(
                  msg => msg.eventID === event.localID
                )
              return {
                ...event,
                bySelf: index !== -1
              }
            }
            return event
          })

          return Rx.Observable.from(
            events.map(event =>
              EventHub.eventUpdate({ event, channel, tag, lastID: event.id })
            )
          )
        } else {
          logger.warn('Unknown subscription tag', tag)
        }
        return Rx.Observable.empty()
      })
  })

export default combineEpics<Epic>(subscribe)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/world/eventHub.ts